import Logger, { Level } from 'core/services/Logger'

const isEnabled = localStorage.getItem('wf_debug')
const logLevel = localStorage.getItem('wf_debug_level') as Level
const logger = new Logger(!!isEnabled, logLevel)

export default logger
